export enum ChatReportFormat {
  Detailed = "Detailed",
  ShortSummary = "Short summary",
  BulletPoints = "Bullet points",
}
